import { MutationTree } from "vuex";
import { IGroupsState } from "./state";
import type { GroupBookingDetail, GroupItem } from "../types";

const mutations: MutationTree<IGroupsState> = {
  setGroupsLoading(state, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  setGroupBookingLoading(state, isBooking: boolean) {
    state.isBooking = isBooking;
  },
  setGroupBookingDetailLoading(state, isLoading: boolean) {
    state.isFetchingBookingDetail = isLoading;
  },
  setGroupPassengersUpdating(state, isUpdating: boolean) {
    state.isUpdatingPassengers = isUpdating;
  },
  setGroupInvoiceCreating(state, isCreating: boolean) {
    state.isCreatingInvoice = isCreating;
  },
  setGroupPayingInvoiceId(state, invoiceId: string | null) {
    state.payingInvoiceId = invoiceId;
  },
  setGroupBookingDetail(state, detail: GroupBookingDetail | null) {
    state.bookingDetail = detail;
  },
  setGroups(state, groups: GroupItem[]) {
    state.groups = groups;
  },
};

export default mutations;
